import { type ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Cancel insurance by ID.
 *
 * @endpoint POST /api/saas/me/insurances/{id}
 * @scope saas
 * @see https://flecto.dev/api-15118055
 */
export async function cancelInsurance(id: ParameterID): Promise<void> {
  await api.post(`/api/saas/me/insurances/${id}/cancel`)
}
